import type { NotificationProps } from '../notification'

import { useNavigate } from 'react-router-dom'

import { Notification } from '../notification'

export interface SymptomNotificationProps extends NotificationProps {
  id: string
  place: string
  clientName: string
  patientId: string
  patientName: string
  symptomName: string
  newSymptomCategory: string
  prevSymptomCategory: string
  createdAt: string
}

export function SymptomNotification ({
  createdAt,
  patientId,
  clientName,
  patientName,
  newSymptomCategory,
  prevSymptomCategory,
  title,
  place,
  symptomName,
  ...rest
}: SymptomNotificationProps): JSX.Element {
  let navigate = useNavigate()

  let categories = prevSymptomCategory === 'N/A'
    ? `New ${newSymptomCategory}`
    : `${prevSymptomCategory} → ${newSymptomCategory}`

  return (
    <Notification
      title='Symptoms'
      date={new Date(createdAt)}
      onClick={() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
        rest.onDismiss()
      }}
      {...rest}
    >
      {patientName} reported {symptomName} {categories}
    </Notification>
  )
}
